import React from 'react'
import { useTranslation } from 'react-i18next'

function isBold(index) {
  return index % 2 === 0 ? 'about-us__text' : 'about-us__text--bold'
}

function AboutUs() {
  const { t } = useTranslation()
  const paragraphs = t('landing.about_us.paragraphs', { returnObjects: true })

  return (
    <div className="about-us">
      <div className="home__title-container">
        <div className="home__title">{t('landing.about_us.title')}</div>
      </div>
      <div className="about-us__text-wrapper">
        {paragraphs.map((p) => (
          <div className="about-us__paragraph">
            <div className="about-us__text">•</div>
            {p.map((text, index) => (
              <div className={`${isBold(index)}`}>{text}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default AboutUs
